import { ClimbType } from "griptonite-api-client";
import { z } from "zod";

import { TaskSet } from "@/core/types";

import { SetType } from "../TaskForm/getSetTypeChoices";

export type CreateTaskSetFormValues = {
  name: string | null;
  startDate: string;
  endDate: string;
  competition: string | null;
  circuit: string | null;
  zone: string | null;
  climbType: ClimbType | null;
  notes: string | null;
  minGradeValue: string | null;
  maxGradeValue: string | null;
  gradeSystem: string | null;
  stripExisting: boolean;
  type: SetType | null;
  routesCount: number | null;
};

export type EditTaskSetFormValues = Omit<
  CreateTaskSetFormValues,
  | "competition"
  | "circuit"
  | "zone"
  | "climbType"
  | "minGradeValue"
  | "maxGradeValue"
  | "gradeSystem"
  | "stripExisting"
  | "type"
  | "routesCount"
>;

export function taskSetToFormValues(taskSet: TaskSet): EditTaskSetFormValues {
  return {
    name: taskSet.name || null,
    startDate: taskSet.startDate,
    endDate: taskSet.endDate,
    notes: taskSet.notes || null,
  };
}

export const TaskFormValuesCreateSchema = z.object({
  name: z.string().nullable(),
  startDate: z.string().date(),
  endDate: z.string().date().nullable(),
  competition: z.string().uuid().nullable(),
  circuit: z.string().uuid().nullable(),
  zone: z.string().nullable(),
  climbType: z.union([z.literal("BOULDER"), z.literal("SPORT")]),
  notes: z.string().nullable(),
  minGradeValue: z.string().nullable(),
  maxGradeValue: z.string().nullable(),
  gradeSystem: z.string().nullable(),
  stripExisting: z.boolean(),
  type: z.string().nullable(),
  routesCount: z.number().nullable(),
});
